// 画像切替PC-SP
// checkBreakpoint 関数を定義
function checkBreakpoint() {
  // スクリーンサイズに基づいてブレークポイントを判定するロジックを追加
  // 例: 768px以下なら 'sp'、それ以外なら 'pc' など
  var screenWidth = window.innerWidth;
  if (screenWidth <= 768) {
    return 'sp';
  } else {
    return 'pc';
  }
}

$(function() {
// replace image
	if (checkBreakpoint() == 'sp') { // sp only
	$('.resize img').each(function() {
		$(this).attr('src', $(this).attr('src').replace('_pc', '_sp'));
	});
	}
});

  // 各要素の高さを揃える
// $(function () {
//   $('.txt_wrap').matchHeight();
//   $('.about_item li').matchHeight();
//   $('.mb_item').matchHeight();
//   $('.txt_wrap, .mb_item, .about_item_txt').matchHeight({
//     disabled: window.innerWidth < 768
//   });
// });


// TO TOP
function smooth_scroll() {
  $('#BackToTop').click(function () {
    var headerHight = 250;
    var speed = 500;
    var href = $(this).attr('href').split("#")[1]; // 修正点
    var target = $(href == "" ? 'html' : '#' + href);
    var position = target.offset().top - headerHight;

    $("html, body").animate({ scrollTop: position }, speed, "swing");
    
    return false;
  });
}

$(document).ready(function () {
  smooth_scroll();
});
